const initialState = {
  lotsWithShippingData: [],
  shippingItemCountAll: 0,
  readyToConfirmCount: 0,
  needsReviewCount: 0,
};

export const GET_SHIPPING_REVIEW_DATA_SUCCESS = 'GET_SHIPPING_REVIEW_DATA_SUCCESS';
export const SET_SHIPPING_ITEM_COUNTS = 'SET_SHIPPING_ITEM_COUNTS';
export const UPDATE_SHIPPING_REVIEW_DATA_SUCCESS = 'UPDATE_SHIPPING_REVIEW_DATA_SUCCESS';
export const UPDATE_SHIPPING_REVIEW_DATA_FAILURE = 'UPDATE_SHIPPING_REVIEW_DATA_FAILURE';
export const GET_ARTA_SUBTYPES_SUCCESS = 'GET_ARTA_SUBTYPES_SUCCESS';
export const SET_SESSION_TITLE = 'SET_SESSION_TITLE';
export const RESET_SHIPPING_REVIEW_DATA = 'RESET_SHIPPING_REVIEW_DATA';
export const IS_SHIPPING_REVIEW_DATA_LOADING = 'IS_SHIPPING_REVIEW_DATA_LOADING';

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_SHIPPING_REVIEW_DATA:
      return initialState;
    case IS_SHIPPING_REVIEW_DATA_LOADING:
      return {
        ...state,
        isShippingReviewDataLoading: action.payload
      };
    case GET_SHIPPING_REVIEW_DATA_SUCCESS:
      return {
        ...state,
        lotsWithShippingData: action.payload,
      };
    case SET_SHIPPING_ITEM_COUNTS:
      return {
        ...state,
        shippingItemCountAll: action.payload.shippingItemCountAll,
        readyToConfirmCount: action.payload.readyToConfirmCount,
        needsReviewCount: action.payload.needsReviewCount,
        inProgressCount: action.payload.inProgressCount,
      };
    case UPDATE_SHIPPING_REVIEW_DATA_SUCCESS:
      return {
        ...state,
        lotsWithShippingData: action.payload.lotsWithShippingData,
        readyToConfirmCount: state.readyToConfirmCount + action.payload.readyToConfirmCountChange,
        needsReviewCount: state.needsReviewCount + action.payload.needsReviewCountChange,
        inProgressCount: state.inProgressCount + action.payload.inProgressCountChange
      };
    case GET_ARTA_SUBTYPES_SUCCESS:
      return {
        ...state,
        artaSubtypeMap: action.payload.artaSubtypeMap,
        artaSubtypeList: action.payload.artaSubtypeList,
      };
    case SET_SESSION_TITLE:
      return {
        ...state,
        sessionTitle: action.payload,
      };
    default:
      return state;
  }
};
